/**
 * playProceduralChime — a standalone, royalty-free soft shimmering bell used as
 * the fallback for the numerology reveal moment when no `chimeSrc` file is
 * configured. Creates a short-lived AudioContext and closes it when finished so
 * it stays completely independent of the ambient engine.
 */
export function playProceduralChime(volume = 0.5) {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return;
  const ctx = new Ctx();
  const bus = ctx.createGain();
  bus.gain.value = volume;
  bus.connect(ctx.destination);

  const bell = (fundamental, gain, decay, startOffset = 0) => {
    const now = ctx.currentTime + startOffset;
    const partials = [1, 2.01, 2.74, 4.06];
    const bowl = ctx.createGain();
    bowl.gain.setValueAtTime(0.0001, now);
    bowl.gain.exponentialRampToValueAtTime(gain, now + 0.03);
    bowl.gain.exponentialRampToValueAtTime(0.0001, now + decay);
    bowl.connect(bus);
    partials.forEach((ratio, i) => {
      const osc = ctx.createOscillator();
      osc.type = "sine";
      osc.frequency.value = fundamental * ratio;
      const g = ctx.createGain();
      g.gain.value = 1 / (i + 1.6);
      osc.connect(g).connect(bowl);
      osc.start(now);
      osc.stop(now + decay + 0.2);
    });
  };

  bell(523.25, 1.0, 4.5, 0);
  bell(783.99, 0.55, 3.5, 0.22);

  // Release the context once the chime has fully decayed.
  setTimeout(() => ctx.close().catch(() => {}), 6000);
}
